var PROFILE_API_KEY_LOAD_URL = '/user/profile/api-key';
var PROFILE_API_KEY_LOAD_SUCCESS = 'PROFILE_API_KEY_LOAD_SUCCESS';
var REDUCER_PROFILE_API_PAGE_NAME = 'profileApiPage';
var USER_PROFILE_API_PAGE_URL = '/user/api';
var USER_PROFILE_NOTIFICATION = '/user/notification';
export { PROFILE_API_KEY_LOAD_URL, PROFILE_API_KEY_LOAD_SUCCESS, REDUCER_PROFILE_API_PAGE_NAME, USER_PROFILE_API_PAGE_URL, USER_PROFILE_NOTIFICATION };